import { useMutation } from "@apollo/client";
import { DocumentTextIcon } from "@heroicons/react/outline";
import { MenuItem } from "@szhsin/react-menu";

import toggleTopicIndividualNoteVisibilityMutation from "@apps/meeting-new/graphql/toggle-topic-individual-note-visibility-mutation";
import { focusTopicEditorWhenReady } from "@apps/meeting-new/helpers";
import { currentUserVar } from "@cache/cache";

const TogglePersonalNotesMenuItem = ({
  topic,
  ...props
}: {
  topic: any;
  meeting: any;
  meetingGroup?: any;
  currentPageMeeting?: any;
}) => {
  const [toggleIndividualNoteVisibility] = useMutation(
    toggleTopicIndividualNoteVisibilityMutation,
  );

  if (topic.includesIndividualNotesForCurrentUser) return null;

  const handleInsertIndividualNotes = async () => {
    // Wait for the mutation to settle before focusing — on slow
    // connections the section won't render (no optimistic response)
    // until the server confirms.
    await toggleIndividualNoteVisibility({
      variables: {
        topicIds: [topic.id],
        enabled: true,
      },
    });
    const currentUser = currentUserVar();
    focusTopicEditorWhenReady(
      topic.id,
      `#topic-${topic.id}-participant-${currentUser.id} .js-topic-discussion-notes-input`,
    );
  };

  return (
    <MenuItem
      className="text-sm"
      onClick={handleInsertIndividualNotes}
      {...props}
    >
      <DocumentTextIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />{" "}
      Insert my notes
    </MenuItem>
  );
};

export default TogglePersonalNotesMenuItem;
